export default [

  // Master -> Sales Hierarchy Master
  {
    path: `/sis/masters/sales-hierarchy-master`,
    name: `sis-masters-sales-hierarchy-master`,
    uri: `/sis/masters/sales-hierarchy-master`,
    component: () => import(`../views/masters/salesHierarchyMaster.vue`),
    meta: {
      title: "Sales Hierarchy Master",
      breadcrumbs: [],
      checkAuth: true,
    },
  },

  // Master -> Sales Hierarchy Configuration
  {
    path: `/sis/masters/sales-hierarchy-configuration`,
    name: `sis-masters-sales-hierarchy-configuration`,
    uri: `/sis/masters/sales-hierarchy-configuration`,
    component: () => import(`../views/masters/salesHierarchyConfiguration.vue`),
    meta: {
      title: "Sales Hierarchy Configuration",
      breadcrumbs: [],
      checkAuth: true,
    },
  },

  // Master -> Sales Hierarchy Upload
  {
    path: `/sis/masters/sales-hierarchy-upload`,
    name: `sis-masters-sales-hierarchy-upload`,
    uri: `/sis/masters/sales-hierarchy-upload`,
    component: () => import(`../views/masters/salesHierarchyUpload.vue`),
    meta: {
      title: "Sales Hierarchy upload",
      breadcrumbs: [],
      // checkAuth: true,
    },
  },
  

  // Scheme Plannig
  {
    path: "/sis/scheme-planning",
    name: "sis-scheme-planning",
    uri: "/sis/scheme-planning",
    component: () => import("../views/scheme-planning/index.vue"),
    meta: {
      title: "Scheme Planning",
      breadcrumbs: [],
      checkAuth: true,
    },
    children: [
      {
        path: "/sis/scheme-planning/scheme",
        name: "sis-scheme",
        uri: "/sis/scheme-planning/scheme",
        component: () => import("../views/scheme-planning/create.vue"),
        meta: {
          title: "Create",
          breadcrumbs: [],
        },
        children: [],
      },
      {
        path: "/sis/scheme-planning/scheme/:id",
        name: "sis-create.id",
        uri: "/sis/scheme-planning/scheme/id",
        component: () => import("../views/scheme-planning/create.vue"),
        meta: {
          title: "Edit",
          breadcrumbs: [],
        },
      },
    ],
  },
];
